export default __webpack_public_path__ + "assets/fonts/01e2a2e8c4e8ffb4ea3f1e0bf96fde3d.woff";